<div class="container-modal">
  <div class="title">
    <span>RECOMENDACIONES, ALERTAS Y NOTIFICACIONES</span>
    <span (click)="setShowModal()">X</span>
  </div>
 
  <div class="filter">
  
    <ion-item class="select ">
      <ion-select label-placement="stacked" interface="popover" [(ngModel)]="selectedItem">
        <ion-select-option [value]="item.id" *ngFor="let item of alertTypes">{{item.name}}</ion-select-option>
      </ion-select>
    </ion-item>

    
  </div>
  <div class="filter-buttons">
    <div> 
      <ion-button *ngIf="notificationsType.length > 0" fill="outline" color="secondary" (click)="cleanAlerts()" >Limpiar</ion-button>
    </div>
    
    <ion-button  color="secondary" (click)="getAlertFilter(selectedItem)" >aplicar</ion-button>
  </div>
  <!-- <app-search *ngIf="notificationsType.length > 0" (enterEvent)="search = $event;"></app-search> -->
  <ion-content>
    <div class="p-3" *ngIf="notificationsType.length <=0 ">No hay registros disponibles . Por favor, presione el botón "Aplicar".</div>
    <ion-list lines="none" *ngFor="let item of notificationsType | filterByProperty : 'dmu_name' : search">
      
      <ion-item >
        <div class="alert">
          <ion-avatar slot="start">
            <img [src]="item.alert_type.icon" alt="Alert Type Icon">
          </ion-avatar>
          <span>{{item.alert_type.name}}</span>
        </div>
        <ion-label>
          <h2>{{item.dmu.name}} - {{item.name}}</h2>
          <p>{{item.date | date : "medium"}}</p>
        </ion-label>
        <ion-button expand="block" color="secondary" (click)=" navigateRute(item)">Ver</ion-button>
      </ion-item>
    </ion-list>
  </ion-content>
</div>
